import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import color from 'src/theme/color';

export const MessagesContainer = styled(Box)({
    flex: 1,
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    scrollbarWidth: 'thin',
    scrollbarColor: `${color.grey2} transparent`,
    '&::-webkit-scrollbar': {
        width: '6px'
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
        background: color.grey2,
        borderRadius: '3px',
        '&:hover': {
            background: color.grey2
        }
    }
});

export const UnreadDivider = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '8px',
    marginBottom: '8px',
    width: '100%'
});

export const UnreadDividerLine = styled(Box)({
    flex: 1,
    height: '1px',
    backgroundColor: color.white30
});

export const UnreadDividerText = styled(Typography)({
    color: color.white70,
    fontSize: '12px',
    fontWeight: 500,
    whiteSpace: 'nowrap'
});
